export default "__VITE_ASSET__Owar$rN5__"